export default __webpack_public_path__ + "static/start-from-scratch-21b5915673335277d79cd425627e8fe5.gif";